import React, { useState, useEffect } from "react"
import ReactModal from 'react-modal'
import PropTypes from "prop-types"
import { Link } from 'gatsby'
import styles from "./navigation.module.css"
import logo from "../../images/logo-fedscoop.png"

// ReactModal.setAppElement('#nav')

const Navigation = ( { type, items } ) => {
    const [modalState,setModalState] = useState(false)
    const showModal = () => setModalState(true)
    const hideModal = () => setModalState(false)
    useEffect( () => {
        window.styles = styles
        ReactModal.setAppElement(document.getElementById('___gatsby'));
    },[])
    return (
        <div className={styles[`${type}__wrapper`]} >
            {type === "hamburger" && <>
                <button className={styles.navBut} onClick={showModal}><i className="fa fa-bars fa-fw"></i></button>
                <ReactModal 
                    className={styles.modal}
                    overlayClassName="Overlay"
                    isOpen={modalState}
                    contentLabel="Navigation"
                    onRequestClose={hideModal}
                    aria={{
                        labelledby: "Navigation",
                        describedby: "Website navigation items"
                    }}
                    shouldReturnFocusAfterClose={false}
                    shouldFocusAfterRender={false}
                    >
                    
                    <button className={styles.closeBut} onClick={hideModal}><i className="fa fa-times fa-fw"></i></button>
                    <div className={styles.menuWrap}>
                        <div className={styles.menuLeft}>
                            <span className={styles.menuHead}>menu</span>
                            <a id="eventbrite-widget-modal-trigger-83981381573" className={styles.regnav}>REGISTER »</a>
                            <span className={styles.socialText}>Follow Us</span><br />
                            <a href="https://www.facebook.com/cyberscoop" target="_blank" rel="noopener noreferrer" className={styles.socialicons}>
                                <i className="fa fa-facebook fa-fw"></i>
                            </a>
                            <a href="https://twitter.com/cyberscoopnews" target="_blanks" rel="noopener noreferrer" className={styles.socialicons}>
                                <i className="fa fa-twitter fa-fw"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/cyberscoop" target="_blank" rel="noopener noreferrer" className={styles.socialicons} onClick={hideModal}>
                                <i className="fa fa-linkedin fa-fw"></i>
                            </a>
                        </div>
                        <div className={styles.menuRight}>
                            {items && items.map( (item, index) => {
                                return <a 
                                    key={index}
                                    onClick={hideModal}
                                    className={styles.navItem}
                                    href={item.url}>
                                        {item.title.toUpperCase()}
                                    </a>
                            })}
                            {/* <a className={styles.navItem} href="#About" onClick={hideModal} >ABOUT</a>
                            <a className={styles.navItem} onClick={hideModal} href="#Sponsors">SPONSOR</a>
                            <a className={styles.navItem} onClick={hideModal} href="#Speakers">SPEAKERS</a>
                            <a className={styles.navItem} onClick={hideModal} href="#Agenda">AGENDA</a>
                            <a className={styles.navItem} href="#venue" onClick={hideModal}>VENUE</a> */}
                            
                            <span className={styles.socialTextmob}>Follow Us</span><br />
                            <a href="https://www.facebook.com/cyberscoop" target="_blank" rel="noopener noreferrer" className={styles.socialiconsmob} onClick={hideModal}>
                                <i className="fa fa-facebook fa-fw"></i>
                            </a>
                            <a href="https://twitter.com/cyberscoopnews" target="_blank" rel="noopener noreferrer" className={styles.socialiconsmob} onClick={hideModal}>
                                <i className="fa fa-twitter fa-fw"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/cyberscoop" target="_blank" rel="noopener noreferrer" className={styles.socialiconsmob} onClick={hideModal}>
                                <i className="fa fa-linkedin fa-fw"></i>
                            </a>
                        </div>
                    </div>
                </ReactModal>
            </>}

            { type === "horizontal" && <>
                <div className={styles[`${type}__branding`]}>
                    <img src={logo} alt="Image logo" className="logo" width="100px"/>
                </div>
                <div className={styles[`${type}__items`]}>
                    {items && items.map( ( item, index ) => 
                        <NavigationItem key={index} title={item.title} url={item.url} /> 
                    )}
                </div>
                <div className={styles[`${type}__dropdown`]}>
                    dropdown items here. Please style accordingly
                </div>
            </>}
        </div>
    )
}

const NavigationItem = ( { title, url } ) => <Link to={url}>{title}</Link>

Navigation.propTypes = {
    type: PropTypes.node.isRequired
}
export default Navigation